import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import logoDark from '@/assets/logo-dark.png';
import logoLight from '@/assets/logo-light.png';
import { useSettings } from '@/store/SettingsContext';

interface LogoProps {
  /** 'full' shows the full-width logo; 'icon' shows it at a compact size */
  variant?: 'full' | 'icon';
  height?: number;
  customSrc?: string;
}

export function Logo({ variant = 'full', height = 36, customSrc }: LogoProps) {
  const theme = useTheme();
  let adminLogo: string | null = null;

  try {
    const settingsContext = useSettings();
    adminLogo = settingsContext.settings.admin_logo;
  } catch {
    // Outside SettingsProvider, fall back safely
  }

  // On dark backgrounds use the light (white) logo; on light backgrounds use the dark logo
  const defaultSrc = theme.palette.mode === 'dark' ? logoLight : logoDark;
  const src = customSrc || adminLogo || defaultSrc;

  return (
    <Box
      component="img"
      src={src}
      alt="Li'l Miracles"
      sx={{
        height: variant === 'icon' ? Math.min(height, 32) : height,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );
}
